<template>
  <div :id="protips.specific_iD" class="protips-block">
    <h2
      v-if="protips.protips_title"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="protip-heading-title"
    >
      {{ protips.protips_title }}
    </h2>
    <h3
      v-if="protips.protips_sub_title"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="protip-subtitle"
    >
      {{ protips.protips_sub_title }}
    </h3>
    <img
      v-if="protips.protips_Image"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="protip-image"
      :src="protips.protips_Image.Src"
      :alt="protips.protips_Image.Alt"
    />
    <div
      v-if="protips.protips_description"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUp' }"
      :class="descriptionBlockStyle(protips)"
    >
      <div v-if="protips.protips_is_description_quote" class="quote-box-component">
        <span class="quotes">&#8220;</span>
        <slot name="quote-description"></slot>
        <span class="quotes">&#8221;</span>
      </div>
      <slot v-else name="text-description"></slot>
    </div>
    <div v-if="protips.protips_video_title || protips.protips_video">
      <h2
        v-if="protips.protips_video_title"
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="video-title"
      >
        {{ protips.protips_video_title }}
      </h2>
      <div
        v-if="protips.video_iD"
        v-animate-onscroll.repeat="{ down: 'animated fadeIn' }"
        class="video-block"
      >
        <videoplaceholder :videoid="protips.video_iD" aspectratio="16by9" :lazy-poster="false">
          <img
            v-if="protips.video_image"
            class="placeholder"
            :src="protips.video_image.Src"
            :alt="protips.video_image.Alt"
          />
        </videoplaceholder>
      </div>
      <div
        v-if="protips.video_videoDescription"
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="protip-video-content"
      >
        <div v-if="protips.video_isVideoDescription_quote" class="quote-box-component">
          <span class="quotes">&#8220;</span>
          <slot name="video-quote-description"></slot>
          <span class="quotes">&#8221;</span>
        </div>
        <slot v-else name="video-description"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'protips',
  props: {
    protips: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const protipBlock = document.getElementById(this.protips.specific_iD);
      if (protipBlock) {
        const checkOffset = protipBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.protips.specific_iD);
        }
      }
    },
    descriptionBlockStyle(protips) {
      const bgcolor = protips.protips_is_bgDescription_white ? 'desc-white-bg' : 'desc-grey-bg';
      const overlap = protips.protips_descriptionNotOverlap
        ? 'protip-content-non-overlap'
        : 'protip-content-block-overlap';
      return `${overlap}  ${bgcolor}`;
    },
  },
};
</script>
